const fontWeights = {
  bold: "normal",
};

export default fontWeights;
